function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "illustrations/development-alt"
}, React.createElement("g", {
  id: "code-editor"
}, React.createElement("g", {
  id: "neutral"
}, React.createElement("g", {
  id: "code"
}, React.createElement("rect", {
  id: "Rectangle",
  x: 86.6462,
  y: 97.5602,
  width: 32.4923,
  height: 10.84,
  rx: 2,
  fill: "#DDDDDD"
}), React.createElement("rect", {
  id: "Rectangle_2",
  x: 140.8,
  y: 119.24,
  width: 32.4923,
  height: 10.84,
  rx: 2,
  fill: "#DDDDDD"
}), React.createElement("rect", {
  id: "Rectangle_3",
  x: 151.631,
  y: 75.88,
  width: 32.4923,
  height: 10.84,
  rx: 2,
  fill: "#DDDDDD"
}), React.createElement("rect", {
  id: "Rectangle_4",
  x: 151.631,
  y: 184.28,
  width: 32.4923,
  height: 10.84,
  rx: 2,
  fill: "#DDDDDD"
}), React.createElement("rect", {
  id: "Rectangle_5",
  x: 86.6462,
  y: 75.88,
  width: 54.1538,
  height: 10.84,
  rx: 2,
  fill: "#DDDDDD"
}), React.createElement("rect", {
  id: "Rectangle_6",
  x: 129.969,
  y: 97.5602,
  width: 54.1538,
  height: 10.84,
  rx: 2,
  fill: "#DDDDDD"
}), React.createElement("rect", {
  id: "Rectangle_7",
  x: 86.6462,
  y: 119.24,
  width: 43.3231,
  height: 10.84,
  rx: 2,
  fill: "#DDDDDD"
}), React.createElement("rect", {
  id: "Rectangle_8",
  x: 86.6462,
  y: 184.28,
  width: 54.1538,
  height: 10.84,
  rx: 2,
  fill: "#DDDDDD"
})), React.createElement("g", {
  id: "divider"
}, React.createElement("line", {
  id: "Line",
  x1: 54.5077,
  y1: 238.48,
  x2: 54.5077,
  y2: 32.52,
  stroke: "#DDDDDD",
  strokeWidth: 2
})), React.createElement("g", {
  id: "rows"
}, React.createElement("rect", {
  id: "Rectangle 2",
  x: 32.4923,
  y: 32.5201,
  width: 16.2462,
  height: 10.84,
  rx: 2,
  fill: "#DDDDDD"
}), React.createElement("rect", {
  id: "Rectangle 2.1",
  x: 32.4924,
  y: 54.1999,
  width: 16.2462,
  height: 10.84,
  rx: 2,
  fill: "#DDDDDD"
}), React.createElement("rect", {
  id: "Rectangle 2.2",
  x: 32.4924,
  y: 75.8801,
  width: 16.2462,
  height: 10.84,
  rx: 2,
  fill: "#DDDDDD"
}), React.createElement("rect", {
  id: "Rectangle 2.3",
  x: 32.4924,
  y: 97.5602,
  width: 16.2462,
  height: 10.84,
  rx: 2,
  fill: "#DDDDDD"
}), React.createElement("rect", {
  id: "Rectangle 2.4",
  x: 32.4924,
  y: 119.24,
  width: 16.2462,
  height: 10.84,
  rx: 2,
  fill: "#DDDDDD"
}), React.createElement("rect", {
  id: "Rectangle 2.5",
  x: 32.4924,
  y: 140.92,
  width: 16.2462,
  height: 10.84,
  rx: 2,
  fill: "#DDDDDD"
}), React.createElement("rect", {
  id: "Rectangle 2.6",
  x: 32.4924,
  y: 161.245,
  width: 16.2462,
  height: 10.84,
  rx: 2,
  fill: "#DDDDDD"
}), React.createElement("rect", {
  id: "Rectangle 2.7",
  x: 32.4924,
  y: 184.28,
  width: 16.2462,
  height: 10.84,
  rx: 2,
  fill: "#DDDDDD"
}), React.createElement("rect", {
  id: "Rectangle 2.8",
  x: 32.4924,
  y: 205.96,
  width: 16.2462,
  height: 10.84,
  rx: 2,
  fill: "#DDDDDD"
}), React.createElement("rect", {
  id: "Rectangle 2.9",
  x: 32.4924,
  y: 227.64,
  width: 16.2462,
  height: 10.84,
  rx: 2,
  fill: "#DDDDDD"
}))), React.createElement("g", {
  id: "brand"
}, React.createElement("rect", {
  id: "Rectangle_9",
  x: 75.8155,
  y: 54.1998,
  width: 32.4923,
  height: 10.84,
  rx: 2,
  fill: "#6534FF"
}), React.createElement("rect", {
  id: "Rectangle_10",
  x: 75.8155,
  y: 162.6,
  width: 21.6615,
  height: 10.84,
  rx: 2,
  fill: "#6534FF"
}), React.createElement("rect", {
  id: "Rectangle_11",
  x: 75.8155,
  y: 140.92,
  width: 32.4923,
  height: 10.84,
  rx: 2,
  fill: "#6534FF"
}), React.createElement("rect", {
  id: "Rectangle_12",
  x: 75.8155,
  y: 205.96,
  width: 21.6615,
  height: 10.84,
  rx: 2,
  fill: "#6534FF"
}), React.createElement("rect", {
  id: "Rectangle_13",
  x: 64.9846,
  y: 32.52,
  width: 21.6615,
  height: 10.84,
  rx: 2,
  fill: "#6534FF"
}), React.createElement("rect", {
  id: "Rectangle_14",
  x: 64.9846,
  y: 227.64,
  width: 21.6615,
  height: 10.84,
  rx: 2,
  fill: "#6534FF"
}))), React.createElement("g", {
  id: "terminal"
}, React.createElement("g", {
  id: "neutral_2"
}, React.createElement("rect", {
  id: "Rectangle 2_2",
  x: 227.446,
  y: 32.52,
  width: 90.7077,
  height: 205.96,
  rx: 2,
  fill: "#DDDDDD"
})), React.createElement("g", {
  id: "accent"
}, React.createElement("rect", {
  id: "Rectangle_15",
  x: 238.277,
  y: 43.36,
  width: 43.3231,
  height: 10.84,
  rx: 2,
  fill: "#FFFAFA"
}), React.createElement("rect", {
  id: "Rectangle_16",
  x: 238.277,
  y: 65.04,
  width: 54.1538,
  height: 10.84,
  rx: 2,
  fill: "#FFFAFA"
}), React.createElement("g", {
  id: ">_"
}, React.createElement("path", {
  d: "M240.053 93.624L244.049 90.408V89.004L240.113 85.812L239.165 87.036L242.525 89.64V89.784L239.153 92.412L240.053 93.624Z",
  fill: "#FFFAFA"
}), React.createElement("path", {
  d: "M251.115 93.9H245.235V95.28H251.115V93.9Z",
  fill: "#FFFAFA"
})))), React.createElement("g", {
  id: "icon"
}, React.createElement("g", {
  id: "brand_2"
}, React.createElement("path", {
  id: "Shape",
  d: "M251.874 212.793C251.094 212.013 251.094 210.747 251.874 209.966L272.062 189.761C272.843 188.979 274.111 188.979 274.892 189.761L280.188 195.061C280.968 195.842 280.968 197.108 280.188 197.888L259.999 218.094C259.218 218.876 257.951 218.876 257.17 218.094L251.874 212.793Z",
  fill: "#6534FF"
})), React.createElement("g", {
  id: "accent_2"
}, React.createElement("path", {
  id: "Shape_2",
  d: "M272.402 196.154C266.587 190.333 266.587 180.896 272.402 175.075C276.351 171.43 281.792 170.027 286.913 171.177C288.295 171.488 288.634 173.175 287.633 174.176L279.478 182.339C279.103 182.714 278.892 183.223 278.892 183.753V187.7C278.892 188.804 279.788 189.7 280.892 189.7H284.91C285.394 189.7 285.863 189.524 286.227 189.204L294.477 181.98C295.483 181.099 297.056 181.442 297.373 182.741C298.541 187.524 297.112 192.658 293.462 196.154C287.647 201.974 278.218 201.974 272.402 196.154Z",
  fill: "#FFFAFA"
}), React.createElement("path", {
  id: "Oval",
  d: "M259.938 212.735C261.434 212.735 262.646 211.522 262.646 210.025C262.646 208.528 261.434 207.315 259.938 207.315C258.443 207.315 257.231 208.528 257.231 210.025C257.231 211.522 258.443 212.735 259.938 212.735Z",
  fill: "white"
}))));

var SvgDevelopmentAlt = function SvgDevelopmentAlt(props) {
  return React.createElement("svg", _extends({
    width: 352,
    height: 271,
    viewBox: "0 0 352 271",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,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";
export { SvgDevelopmentAlt as ReactComponent };